import { ReactNode, useMemo } from 'react';
import { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export function useFieldStateError(
  label: ReactNode,
  error: FieldError | undefined,
): string | undefined {
  const { t } = useTranslation();
  const message = useMemo(() => {
    if (error) {
      if (error.message) {
        return error.message;
      }

      switch (error.type) {
        case 'required':
          return t('{{ label }} is required', { label });
        case 'max':
          return t('{{ label }} is too large', { label });
        case 'min':
          return t('{{ label }} is too small', { label });
        case 'maxLength':
          return t('{{ label }} is too long', { label });
        case 'minLength':
          return t('{{ label }} is too short', { label });
        default:
          return t('{{ label }} is invalid', { label });
      }
    }

    return undefined;
  }, [error, label, t]);

  return message;
}
